<template>
    <div class="classify">
        <h1>
            <span class="title">请选择需要仿写的内容</span>
        </h1>
        <div class="main">
            <img class="bg-img" src="@/assets/image/apart/bg-icon.png" width="210" height="210" />
            <dl v-for="(item) in list" :key="item.key">
                <dt>{{ item.name }}</dt>
                <dd>
                    <div class="checkbox" v-if="item.type === 'select'">
                        <p v-for="(tabItem, i) in item.arr" :key="i" :class="tabItem.selected ? 'selected' : ''"
                            @click="selectClick(tabItem)"><span>
                                {{ tabItem.name }}</span></p>
                    </div>
                    <div class="textarea selectText t-m-t-10" v-if="item.type === 'select'">
                        <el-input v-model="item.modalValues" type="text" placeholder="自定义" show-word-limit
                            :maxlength="100"></el-input>
                    </div>
                    <div class="textarea" v-if="['text', 'textarea'].includes(item.type)">
                        <el-input v-model="item.modalValues" type="textarea" :placeholder="item.placeholder"
                            show-word-limit :maxlength="10000"></el-input>
                    </div>
                    <div class="textarea" v-if="['length'].includes(item.type)">
                        <el-input v-model="item.modalValues" type="number" :placeholder="item.placeholder"></el-input>
                    </div>
                </dd>
            </dl>
        </div>
        <div class="bottom-btn">
            <el-button :loading="loading" @click="btnClick" class="btn"><span>开始仿写</span></el-button>
        </div>
    </div>

</template>
<script>
import apart from '@/api/apart';
import _ from 'lodash'
export default {
    data() {
        return {
            loading: false,
            list: [],
        }
    },
    created() {
        // console.log('初始化仿写')
        apart.mimicClassify().then(res => {
            if (res.code === 200) {
                this.list = res.data.filter(item => {
                    if (item.type === 'select') {
                        item.arr = this.strToArr(item.value).map(r => ({
                            name: r,
                            selected: false,
                        }))
                        item.modalValues = ''
                    } else {
                        item.placeholder = ['length'].includes(item.key) ? `请输入数字(<=${item.value})` : item.value
                        item.modalValues = ''

                    }
                    return item
                })
                // console.log('list组合后=', this.list)
            }
        })

    },
    methods: {
        btnClick() {
            let list = this.list
            let params = {};
            let values = ''
            for (let i in list) {
                if (list[i].type === 'select') {
                    if (!list[i].modalValues && list[i].arr.every(item => !item.selected)) {
                        if (list[i].type !== 'text') {
                            this.$message.warning(`请选择或输入${list[i].name}`)
                            return
                        }
                    }
                    values = list[i].arr.filter(subItem => subItem.selected)
                        .map(subItem => subItem.name)
                        .join(',') //动态参数值
                    if (list[i].modalValues) {
                        if (list[i].arr.every(item => !item.selected)) {
                            values = list[i].modalValues
                        } else {
                            values += ',' + list[i].modalValues
                        }
                    }
                } else {
                    if (['length'].includes(list[i].type) && !list[i].modalValues) {
                        this.$message.warning(`请输入${list[i].name}`)
                        return
                    }
                    if (['length'].includes(list[i].type) && list[i].value && Number(list[i].modalValues) > Number(list[i].value)) {
                        this.$message.warning(`${list[i].name}字数超过${list[i].value}, 已同步最高字数限制`)
                        list[i].modalValues = list[i].value
                        return
                    }
                    values = list[i].modalValues
                }
                params[`${list[i].key}`] = values//组合
            }
            params.chapterId = this.$attrs.chapterId
            params.sign = 'fx'
            // console.log('params=', params)
            sessionStorage.setItem('chapterData', JSON.stringify(params))
            this.$emit('unpack', 'result')
        },
        strToArr(value) {
            if (!value) return []
            return _.split(value, ',')
        },
        selectClick(item) {
            item.selected = !item.selected
        }

    }
}
</script>
<style lang="scss" scoped>
p,
h1,
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}

.selectText {
    ::v-deep(.el-input__count-inner) {
        background-color: transparent !important;
    }
}

.classify {
    display: flex;
    flex: 1;
    flex-direction: column;
    font-family: Microsoft YaHei, Microsoft YaHei;

    h1 {
        height: 56px;
        display: flex;
        justify-content: center;
        position: relative;

        .title {
            width: 240px;
            background: #68482E;
            border-radius: 0px 0px 8px 8px;
            font-weight: bold;
            font-size: 18px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .resultText {
            position: absolute;
            height: 56px;
            line-height: 56px;
            right: 25px;
            font-size: 16px;
            color: var(--tech-primary);
        }
    }

    .main {
        margin-top: 16px;
        padding: 0 24px;
        overflow: auto;
        z-index: 2;
        flex: 1;
        position: relative;
        @include no_scrollbar();

        .bg-img {
            position: absolute;
            top: -20px;
            right: 0;
            z-index: -1;
        }

        dt {
            height: 18px;
            line-height: 18px;
            font-weight: 400;
            font-size: 18px;
            color: #0A0A0A;
            margin-bottom: 24px;
        }

        dd {
            margin-bottom: 32px;

            .checkbox {
                display: grid;
                /* 最小120px，自动换行 */
                grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
                gap: 20px 40px;

                p {
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: #F5F5F5;
                    border-radius: 8px;
                    cursor: pointer;

                    span {
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 16px;
                        color: #472000;
                    }
                }

                .selected {
                    background-color: var(--tech-primary);

                    span {
                        color: #ffffff;
                    }
                }
            }

            .textarea {
                padding: 10px;
                border-radius: 8px;
                background: #F5F5F5;

                textarea {
                    width: 100%;
                    box-sizing: border-box;
                    height: 200px;
                    border: none;
                    resize: none;
                    outline: none;
                    background: #F5F5F5;
                    padding: 16px;
                    color: #555555;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei;

                    &::placeholder {
                        color: #999;
                        opacity: 1;
                        /* 某些浏览器（如 Firefox）默认 placeholder 透明度较低，可以强制设为 1 */
                    }

                    @include scrollbar();

                    &:hover {
                        @include scrollbar_hover();
                    }
                }

                ::v-deep(.el-textarea__inner) {
                    background-color: #F5F5F5;
                    border: 0;
                    color: #555555;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    height: 200px;

                    &+.el-input__count {
                        background-color: transparent;
                    }

                    &::placeholder {
                        color: #999;
                        opacity: 1;
                        /* 某些浏览器（如 Firefox）默认 placeholder 透明度较低，可以强制设为 1 */
                    }
                }

                ::v-deep(.el-input__inner) {
                    background-color: #F5F5F5;
                    border: 0;
                    color: #555555;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei;

                    &::placeholder {
                        color: #999;
                        opacity: 1;
                        /* 某些浏览器（如 Firefox）默认 placeholder 透明度较低，可以强制设为 1 */
                    }
                }
            }
        }

    }

    .bottom-btn {
        height: 66px;
        width: 100%;
        background: #FFFFFF;
        border-top: 1px solid #EEEEEE;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn {
            width: 160px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--tech-primary);
            border-radius: 8px;
            border: none;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }

            span {
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 16px;
            }
        }

        .default {
            background-color: #ffffff;
            border: 1px solid var(--tech-primary);

            span {
                color: var(--tech-primary);
            }
        }
    }
}
</style>